import { useCallback, useState } from 'react'
import { ResultSkinRecommendedProduct } from '../../../types'

interface Props {
  onExpose?: (productId: string) => void
  products: readonly ResultSkinRecommendedProduct[]
}

interface FeaturedProductCarouselController {
  activeIndex: number
  onIndexChange: (index: number) => void
}

/**
 * useFeaturedProductCarouselController — 轮播状态和曝光意图保持在 Hook 中，避免展示组件放开 Swiper 裁剪区域。
 * @returns {FeaturedProductCarouselController} 当前轮播索引及切换回调
 */
const useFeaturedProductCarouselController = ({ onExpose, products }: Props): FeaturedProductCarouselController => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const activeIndex = Math.min(currentIndex, Math.max(products.length - 1, 0))

  const handleIndexChange = useCallback((index: number) => {
    const product = products[index]
    if (!product) {
      return
    }
    setCurrentIndex(index)
    onExpose?.(product.id)
  }, [onExpose, products])

  return {
    activeIndex,
    onIndexChange: handleIndexChange,
  }
}

export default useFeaturedProductCarouselController
